<template>
  <ob-admin-section
    type="date"
    :xlsx="true"
    has-perioade
    import-headers-btn
    :confirm-value="confirm.dialog"
    @confirmed="_cbConfirmed">

    <template slot="section-title">Sectiune Date Financiare</template>

    <template slot="toolbar-title">Baza de date Date Financiare</template>

    <template slot="fab">
      <v-speed-dial
        class="ob-speed-dial"
        v-model="fab"
        absolute
        fixed
        bottom
        right
        direction="top"
        open-on-hover
        transition="scroll-y-reverse-transition"
        key="speeddial">
        <v-btn
          slot="activator"
          v-model="fab"
          color="accent"
          dark
          fab
          key="speed"
          :loading="!!remainingFiles || !!remainingMassiveFiles">
          <v-icon>mdi-menu</v-icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-tooltip left>
          <span slot="activator">
            <v-btn
              :disabled="!!remainingFiles || !!remainingMassiveFiles"
              fab
              small
              color="success"
              @click="_cbOpenUploadDialog">
              <v-icon v-if="!remainingFiles">mdi-file-upload</v-icon>
              <template v-else>
                {{ remainingFiles }}
              </template>
            </v-btn>
          </span>
          <span>Selecteaza manual fisiere</span>
        </v-tooltip>
        <v-tooltip left>
          <span slot="activator">
            <v-btn
              :disabled="!!remainingFiles || !!remainingMassiveFiles"
              fab
              small
              color="success"
              @click="_cbOpenDirectoryPicker">
              <v-icon v-if="!remainingMassiveFiles">mdi-folder</v-icon>
              <template v-else>
                {{ remainingMassiveFiles }}
              </template>
            </v-btn>
          </span>
          <span>Selecteaza un folder</span>
        </v-tooltip>
        <v-tooltip left>
          <span slot="activator">
            <v-btn
              fab
              small
              color="info"
              @click="_cbParseExistingFiles">
              <v-icon>mdi-file-excel</v-icon>
            </v-btn>
          </span>
          <span>Citeste date din fisiere deja existente pe server</span>
        </v-tooltip>
      </v-speed-dial>
    </template>

    <template slot="dialogs">
      <ob-dialog :value="bulkUploadDialog" :max-width="500" @close="_cbCloseDialog" key="bulkUploadDialog">
        <template slot="title">
          Import in masa date financiare din fisiere xls(x)
        </template>
        <template slot="content">
          <form ref="bulkUploadForm">
            <input type="file" multiple ref="filesInput">
            <br>
            <v-checkbox
              v-for="tab in tabs"
              :key="tab._id"
              v-model="bulkUploadTabs"
              :label="tab.label"
              :value="tab._id"
              hide-details
              :disabled="!['mfven', 'mfch'].includes(tab._id)">
            </v-checkbox>
          </form>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbCloseDialog">Anulare</v-btn>
          <v-btn flat color="primary" @click="_cbStartUpload">Incarcare</v-btn>
        </template>
      </ob-dialog>
      <ob-dialog :value="massiveUploadDialog" :max-width="500" @close="_cbCloseMassiveDialog" key="massiveUploadDialog">
        <template slot="title">
          Import in masa date financiare din fisiere xls(x) aflate intr-o ierarhie de foldere
        </template>
        <template slot="content">
          <form ref="massiveUploadForm">
            <v-btn color="primary" :disabled="readingFolder" :loading="readingFolder" @click="_cbSetFolder">
              Alege folder
            </v-btn>
            <v-chip v-if="workingFolderHandle" color="primary" label dark>
              <span class="mr-2">
                <v-icon color="white" small>
                  mdi-folder
                </v-icon>
                  {{ workingFolderHandle.name }}
              </span>
              <span>
                <v-icon color="white" small>
                  mdi-file-excel
                </v-icon>
                  {{ massiveFiles.length }}
              </span>
            </v-chip>
            <br>
            <v-checkbox
              v-for="tab in tabs"
              :key="tab._id"
              v-model="massiveUploadTabs"
              :label="tab.label"
              :value="tab._id"
              hide-details
              :disabled="!['mfven', 'mfch'].includes(tab._id)">
            </v-checkbox>
          </form>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbCloseMassiveDialog">Anulare</v-btn>
          <v-btn flat color="primary" @click="_cbStartMassiveUpload" :disabled="!massiveFiles.length || !massiveUploadTabs.length || readingFolder">Incarcare</v-btn>
        </template>
      </ob-dialog>
    </template>
  </ob-admin-section>
</template>

<script>
import AdminSection from '@/components/AdminSection'
import Dialog from '@/components/Dialog'

export default {
  name: 'date',
  components: {
    'ob-admin-section': AdminSection,
    'ob-dialog': Dialog
  },
  data: () => ({
    type: 'date',
    fab: null,
    confirm: {
      dialog: false,
      callback: null
    },
    bulkUploadDialog: false,
    bulkUploadTabs: [],

    massiveUploadTabs: [],
    massiveUploadDialog: false,
    workingFolderHandle: null,

    readingFolder: false,
    massiveFiles: []
  }),
  computed: {
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    },
    remainingFiles () {
      return this.$store.getters[`${this.type}/remainingFiles`]
    },
    remainingMassiveFiles () {
      return this.$store.getters[`${this.type}/remainingMassiveFiles`]
    },
    perioadeTabs () {
      return this.$store.getters[`${this.type}/perioadeTabs`]
    },
    selectedPerioadeTab () {
      return this.$store.getters[`${this.type}/selectedPerioadeTab`]
    }
  },
  methods: {
    _cbConfirmed (value) {
      if (value && this.confirm.callback) this[this.confirm.callback]()
      this.confirm.dialog = false
      this.confirm.callback = null
    },

    _cbOpenUploadDialog () {
      this.bulkUploadDialog = true
    },
    _cbOpenDirectoryPicker () {
      this.massiveUploadDialog = true
    },
    _cbCloseDialog () {
      this.bulkUploadDialog = false
      this.resetBulkUploadForm()
    },
    _cbCloseMassiveDialog () {
      this.massiveUploadDialog = false
      this.resetMassiveUploadForm()
    },
    _cbStartUpload () {
      const files = this.$refs.filesInput.cloneNode().files
      if (!files.length) return
      this.$store.dispatch(this.type + '/bulkUpload', { files, tabs: [...this.bulkUploadTabs] })
      this.bulkUploadDialog = false
      this.resetBulkUploadForm()
    },

    _cbStartMassiveUpload () {
      // send to worker
      // { files: [...this.massiveFiles], tabs: [...this.massiveUploadTabs] }
      this.$store.dispatch(this.type + '/massiveUpload', { files: [...this.massiveFiles], tabs: [...this.massiveUploadTabs] })
      this.massiveUploadDialog = false
      this.resetMassiveUploadForm()
    },

    resetBulkUploadForm () {
      this.$refs.bulkUploadForm.reset()
      this.bulkUploadTabs = []
    },
    resetMassiveUploadForm () {
      this.$refs.massiveUploadForm.reset()
      this.massiveUploadTabs = []
      this.massiveFiles = []
    },

    async _cbSetFolder () {
      try {
        this.workingFolderHandle = await window.showDirectoryPicker()
        await this.readFolder()
      } catch (err) {
        console.log(err)
      }
    },
    async readFolder () {
      if (!this.workingFolderHandle) return
      try {
        this.massiveFiles = []
        this.readingFolder = true

        await this.getFiles(this.workingFolderHandle)

        this.massiveFiles = [ ...foundFiles ]
        foundFiles.length = 0

        this.readingFolder = false
      } catch (err) {
        console.log(err)
      }
    },

    async getFiles (folder) {
      if (!folder) return
      try {
        for await (const entry of folder.values()) {
          if (entry.kind === 'file') {
            const ext = entry.name.split('.').pop()
            if (['xls', 'xlsx'].includes(ext)) {
              const file = await entry.getFile()
              foundFiles.push(file)
            }
          } else if (entry.kind === 'directory') {
            await this.getFiles(entry)
          }
        }
      } catch (err) {
        console.log(err)
      }
    },

    _cbParseExistingFiles () {
      const perioada = this.perioadeTabs[this.selectedPerioadeTab]
      const parts = perioada.label.split('-')
      const year = parts[0]
      const quarter = Math.ceil(((+parts[1][1]) / 3))

      this.$store.dispatch('date/parseExistingFiles', {
        label: `${year}-T${quarter}`,
        id: perioada._id,
        actions: {
          download: false,
          parse: true,
          compute: false
        }
      })
    }
  },
  created () {
    this.$store.dispatch('date/setEventWatchers')
    this.$store.dispatch('date/fetchHeaders')
    this.$store.dispatch('date/fetchItems')
    this.$store.dispatch('date/fetchPerioadeTabs')

    this.$store.dispatch('date/setupBulkUploadWorker')
    this.$store.dispatch('date/sendUserToBulkUploadWorker')

    this.$store.dispatch('date/setupMassiveUploadWorker')
    this.$store.dispatch('date/sendUserToMassiveUploadWorker')
  }
}

const foundFiles = []
</script>

<style>

</style>
